<template>
	<div class="progress-line">
		<div class="progress-puzzle" :class="isBigState ? 'big-left ' : 'sm-left '">
			<span v-show="examName" class="progress-basicInfo">
				[{{ examInfo.examInfo.pkId }}] {{ examInfo.examInfo.examName }} | {{ examInfo.gradeName }}{{ examInfo.examSubject }} | {{ examInfo.paperRange }}
				<guide class="basic-info-guide" v-show="guideStep === 0" title="基本信息" distribute="包括考试科目，年级，课目" :isShowPrev="false" />
			</span>
			<span class="my-progress" v-if="allotType === 1 || query.type === '3'">
				个人进度：{{ personProgress.markingedCount || 0 }}
				<guide class="my-progress-guide" v-show="guideStep === 1" title="个人进度" distribute="个人阅卷进度" />
			</span>
			<span class="my-progress" v-else>
				个人进度：{{ `${personProgress.markingedCount || 0} / ${personProgress.markingTaskNum || 0}` }}
				<guide class="my-progress-guide" v-show="guideStep === 1" title="个人进度" distribute="个人阅卷进度" />
			</span>
		</div>
		<div class="progress-normal" :class="isBigState ? 'sm-right ' : 'big-right'" v-if="query.type === '2'">
			<span>{{ `进度(${personProgress.hardMarkingedSum || '0'} / ${personProgress.hardMarkingSum || '0'})：` }}</span>
			<el-progress
				:text-inside="true"
				:stroke-width="20"
				color="#009688"
				:percentage="Number(((personProgress.hardMarkingedSum * 100) / personProgress.hardMarkingSum).toFixed(2)) || 0"
				v-if="personProgress.markingSum > 0"
			></el-progress>
			<el-progress :text-inside="true" :stroke-width="20" :percentage="0" color="#009688" v-else></el-progress>
			<guide class="total-progress-guide" v-show="guideStep === 2" title="进度" distribute="当前模块阅卷进度" />
		</div>
		<div class="progress-normal" :class="isBigState ? 'sm-right ' : 'big-right'" v-else>
			<span>{{ `进度(${personProgress.markingedSum || '0'} / ${personProgress.markingSum || '0'})：` }}</span>
			<el-progress
				:text-inside="true"
				:stroke-width="20"
				color="#009688"
				:percentage="Number(((personProgress.markingedSum * 100) / personProgress.markingSum).toFixed(2)) || 0"
				v-if="personProgress.markingSum > 0"
			></el-progress>
			<el-progress :text-inside="true" :stroke-width="20" :percentage="0" color="#009688" v-else></el-progress>
			<guide class="total-progress-guide" v-show="guideStep === 2" title="进度" distribute="当前模块阅卷进度" />
		</div>
	</div>
</template>

<script>
import guideMixin from '../utils/guide-mixin'

export default {
	name: 'progressLine',
	mixins: [guideMixin],
	data() {
		return {
			query: this.$route.query,
			//no use
			cacheNextData: false,
			//基本信息
			basicInfo: {},
			//进度
			personProgress: {},
			//阅卷类型
			allotType: null,
			//科目名称
			examName: '',
			examSubjectName: '',
			//考试信息
			examInfo: {
				examInfo: { pkId: '' }
			},
			//进度条显示状态
			isBigState: false
		}
	},
	components: {
		guide: () => import('./guide')
	},
	mounted() {
		this.getProState()
	},
	methods: {
		getProState() {
			this.eventBus.$on('isCacheNextData', cb => {
				this.cacheNextData = cb
			})
			this.eventBus.$on('allotType', cb => {
				this.allotType = cb
			})
			this.eventBus.$on('personProgress', cb => {
				this.personProgress = cb
			})
			this.eventBus.$on('basicInformation', cb => {
				this.basicInfo = cb
			})
			this.eventBus.$on('examBaseInfo', cb => {
				if (cb.examInfo) this.isBigState = true
				this.examInfo = cb
				this.examName = cb.examInfo?.examName || ''
				this.examSubjectName = cb.examSubject || ''
			})
		}
	}
}
</script>

<style scoped lang="less">
.progress-line {
	width: 100%;
	height: 30px;
	padding: 10px 0 0 8px;
	background: #f5f5f5;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	@media screen and (max-width: 1920px) {
		height: 25px;
		padding: 5px 0 0 8px;
	}
	.progress-normal {
		width: calc(100% - 500px);
		height: 100%;
		display: flex;
		justify-content: flex-start;
		align-content: center;
		margin-left: 2%;
		/deep/ .el-progress {
			width: calc(100% - 210px);
		}
	}
	.bg-right {
		width: calc(100% - 250px);
	}
	.sm-right {
		width: calc(100% - 850px);
	}
	.progress-puzzle {
		width: 500px;
		height: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		.exam-name {
			max-width: 200px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		&:after {
			content: '';
			width: 1px;
			height: 19px;
			background: #a29a9a;
			margin-top: 3px;
		}
		/deep/ .el-progress {
			width: calc(100% - 180px);
		}
	}
	.big-left {
		width: 850px;
	}
	.sm-left {
		width: 250px;
	}

	.person-progress {
		padding-right: 30px;
	}
}
</style>
